import i18n from 'i18next';
import { DashboardCurrency } from '../entities';

const getLanguage = (): string => {
  return i18n.language || (typeof window !== 'undefined' && (window.localStorage.i18nextLng as string)) || 'en-GB';
};

export function localiseCurrency(
  num: number,
  baseCurrency: DashboardCurrency,
  isCompact = false,
  language = getLanguage(),
) {
  const defaultOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: baseCurrency,
  };
  const compactOptions = { notation: 'compact' };
  const options: Intl.NumberFormatOptions = isCompact
    ? { ...defaultOptions, ...(compactOptions as Intl.NumberFormatOptions) }
    : { ...defaultOptions, minimumFractionDigits: 2, maximumFractionDigits: 2 };

  return formatNumber(num, options, language);
}

export function localiseNumber(num: number, isCompact = false, language = getLanguage()) {
  const options: Intl.NumberFormatOptions = isCompact ? { notation: 'compact' } : {};

  return formatNumber(num, options, language);
}

export function formatNumber(num: number, options: Intl.NumberFormatOptions, language = 'en-GB') {
  const normalizeLegacyCompactSuffix = (formatted: string): string => {
    if (options.notation !== 'compact') {
      return formatted;
    }

    // Keep historical compact suffix output stable across Node Intl versions.
    return formatted.replace(/(bn|tn|k|m)\b/gi, suffix => {
      const normalizedSuffixes: Record<string, string> = {
        k: 'K',
        m: 'M',
        bn: 'B',
        tn: 'T',
      };
      return normalizedSuffixes[suffix.toLowerCase()] ?? suffix;
    });
  };

  try {
    // Format the number with the supplied options and language
    return normalizeLegacyCompactSuffix(new Intl.NumberFormat([language, 'en-GB'], options).format(num));
  } catch (error) {
    try {
      // Try again with just the default en-GB language
      return normalizeLegacyCompactSuffix(new Intl.NumberFormat('en-GB', options).format(num));
    } catch (error) {
      // If that fails just return the unformatted number as a fallback
      return num.toString();
    }
  }
}
